import { render, staticRenderFns } from "./EditTeamDetail.vue?vue&type=template&id=1c0613e2"
import script from "./EditTeamDetail.vue?vue&type=script&lang=js"
export * from "./EditTeamDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports